import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FOR_INVESTORS_SECTIONS, FOR_INVESTORS_SUB_SECTIONS } from 'constants/businessToolSections/forInvestors';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { TextInputControl } from 'components/_basic/Form/TextInput';
import { FormHeader } from 'components/_basic/FormHeader/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';
import {
  LOCATION_AND_PREMISES_NAMES,
  prefix,
} from 'components/BusinessToolForm/Sections/BusinessOperations/LocationAndPremises/utils/form';

import { concatWithDot } from 'helpers/string';

export const LocationAndPremises: React.FC = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS,
    FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_BUSINESS_OPERATIONS.LOCATION_AND_PREMISES,
  );

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          locked={!canAccess}
          title={t('businessOperations.title')}
          badgeText={t('businessOperations.location.title')}
          section={FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS}
        />
      </FormSectionCard>
      {/* 6.1.1 */}
      <FormSectionCard
        disabled={!canAccess}
        title={t('businessOperations.location.currentLocation')}
        aiFieldName={concatWithDot(prefix, LOCATION_AND_PREMISES_NAMES.LOCATION)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, LOCATION_AND_PREMISES_NAMES.LOCATION)}
          name={concatWithDot(prefix, LOCATION_AND_PREMISES_NAMES.LOCATION)}
          minRows={4}
          disabled={!canAccess}
          maxLength={1500}
        />
      </FormSectionCard>
      {/* 6.1.4 */}
      <FormSectionCard
        disabled={!canAccess}
        title={t('businessOperations.location.futurePlans')}
        aiFieldName={concatWithDot(prefix, LOCATION_AND_PREMISES_NAMES.FUTURE_PLANS)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, LOCATION_AND_PREMISES_NAMES.FUTURE_PLANS)}
          name={concatWithDot(prefix, LOCATION_AND_PREMISES_NAMES.FUTURE_PLANS)}
          minRows={4}
          disabled={!canAccess}
          maxLength={1500}
        />
      </FormSectionCard>
    </>
  );
};
